import React from 'react';
import SettlementRateDistributionComponent from "./SettlementRateDistributionComponent";

const removeRibbon = (aggregateDamages) => {
	if (!aggregateDamages) {
		return 0;
	}
	return aggregateDamages
		.filter(y => y.damageType == 'COMPLETE_DAMAGES')[0].maxDollarOfArtificialInflationPerShare;
};

const getBands = (data, aggDam) => {
	if(typeof aggDam !== 'undefined' && aggDam >= 0 && data && data.length > 1) {
		
		return data.filter(function (b) {
			return aggDam >= b.settlementRateBandMin && (aggDam < b.settlementRateBandMax || b.settlementRateBandMax === null);
		});
	} else {
		return data;
	}
};

const SettlementRateDistributionContainer = (props) => {
	return (
		<React.Fragment>
			<SettlementRateDistributionComponent currentSettlementRateBand={getBands(props.currentSettlementRateBands, removeRibbon(props.aggregateDamages))} /> 
		</React.Fragment>
	);

};


export default SettlementRateDistributionContainer;



// WEBPACK FOOTER //
// ./src/common/components/SettlementRateDistribution/SettlementRateDistributionContainer.js